/*
 * <kw-ac-konfigurator> – 5-step quote wizard (sections/klimaanlagen-konfigurator.liquid).
 * Option tiles fill the hidden form inputs and advance, back buttons reset later answers,
 * a summary tile per answer is shown, info icons open a small modal.
 * Step headings come from the JSON island [data-kwkr-config].
 */
if (!customElements.get("kw-ac-konfigurator")) {
  customElements.define(
    "kw-ac-konfigurator",
    class KwAcKonfigurator extends HTMLElement {
      static FIELDS = ["Gebäudeart", "Räume", "Fläche", "Inneneinheit"];
      static PROGRESS = { 1: 20, 2: 40, 3: 60, 4: 80, 5: 99 };
      static MODALS = {
        email: {
          title: "EMAIL",
          text: "Für die Übermittlung des Angebots oder schriftliche Rückfragen benötigen wir Ihre E-Mail. Diese Daten werden nicht an Dritte weitergegeben.",
        },
        telefon: {
          title: "TELEFON",
          text: "Ihre Telefonnummer wird benötigt, um Ihnen bei Fragen schnell weiterhelfen zu können.",
        },
        plz: {
          title: "POSTLEITZAHL",
          text: "Die Postleitzahl hilft uns, Ihnen passende regionale Angebote bereitzustellen.",
        },
      };

      connectedCallback() {
        this.root = this.querySelector(".kwkr-container");
        if (!this.root) return;
        try {
          this.headings = JSON.parse(this.querySelector("[data-kwkr-config]").textContent).headings;
        } catch (error) {
          this.headings = {};
        }
        this.progressBar = this.root.querySelector('[data-role="progress-bar"]');
        this.stepHeading = this.root.querySelector('[data-role="step-heading"]');
        this.summary = this.root.querySelector('[data-role="summary-container"]');
        this.modal = this.root.querySelector('[data-role="modal"]');
        this.currentStep = 1;

        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.root.addEventListener("click", (event) => this.onClick(event), { signal });

        this.updateProgressBar();
        this.stepHeading.innerText = this.headings[1] || "";

        // After a submit, show the success or error message above the wizard
        const status = this.root.querySelector(".kwkr-form-status");
        const header = this.root.querySelector(".kwkr-global-header");
        if (status && header) header.parentNode.insertBefore(status, header);
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      onClick(event) {
        const tile = event.target.closest(".kwkr-option-tile");
        if (tile) {
          this.selectOption(tile.dataset.field, tile.dataset.value, tile.dataset.next);
          return;
        }
        const back = event.target.closest("[data-prev]");
        if (back) {
          this.goToStep(back.dataset.prev);
          return;
        }
        const tip = event.target.closest("[data-modal]");
        if (tip) this.openModal(tip.dataset.modal, tip);
      }

      selectOption(field, value, nextStep) {
        const input = this.root.querySelector(`[data-input="${field}"]`);
        if (input) input.value = value;
        this.updateSummary(field, value);
        this.goToStep(nextStep);
      }

      goToStep(step) {
        step = parseInt(step, 10);
        // Going back clears the answers of the later steps
        if (step < this.currentStep) {
          KwAcKonfigurator.FIELDS.slice(step).forEach((field) => {
            this.summary.querySelector(`[data-summary="${field}"]`)?.remove();
            const input = this.root.querySelector(`[data-input="${field}"]`);
            if (input) input.value = "";
          });
        }
        this.root.querySelectorAll(".kwkr-step").forEach((el) => el.classList.remove("kwkr-active"));
        this.root.querySelector(`[data-step="${step}"]`)?.classList.add("kwkr-active");
        this.currentStep = step;
        this.updateProgressBar();
        this.stepHeading.innerText = this.headings[step] || "";
      }

      updateProgressBar() {
        const progress = KwAcKonfigurator.PROGRESS[this.currentStep];
        this.progressBar.style.width = `${progress}%`;
        this.progressBar.setAttribute("data-progress", progress);
      }

      updateSummary(field, value) {
        let tile = this.summary.querySelector(`[data-summary="${field}"]`);
        if (!tile) {
          tile = document.createElement("div");
          tile.setAttribute("data-summary", field);
          tile.className = "kwkr-summary-tile";
          this.summary.appendChild(tile);
        }

        const normalize = (str) => String(str).toLowerCase().replace(/²/g, "2").replace(/\s+/g, " ").trim();
        const optionImage = [...this.root.querySelectorAll(".kwkr-option-tile img")].find(
          (img) => normalize(img.getAttribute("alt") || "") === normalize(value)
        );

        const text = document.createElement("div");
        text.style.cssText = "flex:1;text-align:left;word-break:break-word;";
        const label = document.createElement("strong");
        label.textContent = `${field}:`;
        text.append(label, ` ${value}`);
        tile.replaceChildren(text);

        if (optionImage) {
          const icon = document.createElement("img");
          icon.src = optionImage.getAttribute("src");
          icon.alt = optionImage.getAttribute("alt") || value;
          icon.style.cssText = "width:50px;height:50px;object-fit:contain;margin-left:8px;";
          tile.append(icon);
        }
      }

      openModal(key, opener) {
        const content = KwAcKonfigurator.MODALS[key];
        if (!content || !this.modal) return;
        this.modal.querySelector('[data-role="modal-title"]').innerText = content.title;
        this.modal.querySelector('[data-role="modal-text"]').innerText = content.text;
        // <cdx-dialog>: focus trap, Escape, backdrop click and focus return to the info icon
        this.modal.open(opener);
      }
    }
  );
}
